const $ = require('jquery');

const ModalMsiClient = require('../../../modal-msi/client/js');
const ModalOriginsClient = require('../../../modal-origins/client/js');
const HeaderMasterExpedient = require('../../../header-master-expedient/client/js');

const { initWelcome } = require('./welcome');
const { initTooltips } = require('./tooltip');
const { getCookie, setCookie } = require('./cookie');

// eslint-disable-next-line max-statements
$(() => {
    // Welcome
    initWelcome();

    // Tooltips
    initTooltips();

    // Modal Origins
    ModalOriginsClient('.Header [data-component="Modal"][data-type="modal-origins"]', {
        modal: {
            triggers: [document.querySelector('.Header [data-modal-open="modal-origins"]')]
        }
    });

    // Modal MSI
    ModalMsiClient('.Header [data-component="Modal"][data-type="modal-msi"]', {
        modal: {
            triggers: [...document.querySelectorAll('[data-modal-open="modal-msi"]')]
        }
    });

    // Header Master Expedient
    HeaderMasterExpedient('[data-component="HeaderMasterExpedient"]');

    // Login Modal
    const modalCookie = getCookie('login_modal_closed');
    const closeButton = $('.close-button');
    const loginModal = $('#loginModal');
    const warningCookie = 'warning_closed';

    closeButton.click(() => {
        document.cookie = 'login_modal_closed=1; expire=; path=/;';
        loginModal.css('display', 'none');
    });

    if (loginModal && modalCookie === '') {
        setTimeout(() => {
            loginModal.css('display', 'block');
        }, 6000);
    }

    /* Event to close top warning and cookies */
    checkWarning(warningCookie);
    $('.message-alert__content-close').on('click', () => {
        setCookie(warningCookie);
        $(`.message-alert`).addClass('message-alert__hidden');
    });

    // DROPDOWN LANGUAGE ITEM CLICK EVENT
    $('.options-list__item--language').on('click', () => {
        const elementLanguageDropdown = $('.dropdown--language .dropdown__item');
        if (elementLanguageDropdown) {
            elementLanguageDropdown.on('click', event => {
                const config = JSON.parse($('.dropdown--language').attr('data-config'));
                const languageSelected = event.currentTarget.dataset.language;

                if (config.language_url) {
                    $.ajax({
                        contentType: 'application/json; charset=utf-8',
                        data: JSON.stringify({
                            language: languageSelected
                        }),
                        dataType: 'json',
                        success: () => {
                            window.parent.location.reload();
                        },
                        type: 'POST',
                        url: config.language_url
                    });
                } else {
                    console.warn("WARNING: Origin url hasn't been defined.");
                }
            });
        }
    });

    // DROPDOWN CURRENCY ITEM CLICK EVENT
    $('.options-list__item--currency').on('click', () => {
        const elementCurrencyDropdown = $('.dropdown--currency .dropdown__item');
        if (elementCurrencyDropdown) {
            elementCurrencyDropdown.on('click', event => {
                const config = JSON.parse($('.dropdown--currency').attr('data-config'));
                const currencySelected = event.currentTarget.dataset.currency;

                if (config.currency_url) {
                    $.ajax({
                        contentType: 'application/json; charset=utf-8',
                        data: JSON.stringify({
                            currency: currencySelected
                        }),
                        dataType: 'json',
                        success: () => {
                            window.parent.location.reload();
                        },
                        type: 'POST',
                        url: config.currency_url
                    });
                } else {
                    console.warn("WARNING: Origin url hasn't been defined.");
                }
            });
        }
    });
});

addClassActive('.options-list__item--currency', '.dropdown--currency');
addClassActive('.options-list__item--language', '.dropdown--language');

function addClassActive(listItemClass, dropdownClass) {
    const listItem = $(listItemClass);
    const dropdown = $(dropdownClass);

    if (dropdown.hasClass('dropdown--language') || dropdown.hasClass('dropdown--currency')) {
        listItem.addClass('active');
    } else {
        listItem.removeClass('active');
    }
}

const userAgent = navigator.userAgent.toLowerCase();
// eslint-disable-next-line max-len
const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
    userAgent
);

if (isTablet) {
    $('.Header .menu-tabs .menu-item.dropdown').on('click', e => {
        if ($(e.currentTarget).hasClass('js-menu-clicked')) {
            return true;
        }
        $('.Header .menu-tabs .menu-item.dropdown').removeClass('js-menu-clicked');
        $(e.currentTarget).addClass('js-menu-clicked');
        e.preventDefault();
        return false;
    });
}

function checkWarning(cookie) {
    if (getCookie(cookie) === '') {
        $(`.message-alert`).removeClass('message-alert__hidden');
    }
}
